var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-card",class:[ 'border-theme-' + _vm.theme ,{'multi-line-padding': _vm.multiLinePadding} ,{'multi-line-no-padding': _vm.multiLineNoPadding} ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }